// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-app {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .loading {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #666;
  }
  
  .error {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #d32f2f;
    background-color: #ffebee;
    border-radius: 4px;
  }
  
  .no-results {
    text-align: center;
    padding: 60px 20px;
    font-size: 18px;
    color: #666;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
  
  /* Add more global styles as needed */`, "",{"version":3,"sources":["webpack://./assets/css/PropertyListingContainer.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,qCAAqC","sourcesContent":[".property-app {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n  }\n  \n  .loading {\n    text-align: center;\n    padding: 40px;\n    font-size: 18px;\n    color: #666;\n  }\n  \n  .error {\n    text-align: center;\n    padding: 40px;\n    font-size: 18px;\n    color: #d32f2f;\n    background-color: #ffebee;\n    border-radius: 4px;\n  }\n  \n  .no-results {\n    text-align: center;\n    padding: 60px 20px;\n    font-size: 18px;\n    color: #666;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n  }\n  \n  /* Add more global styles as needed */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
